'use strict';

var util = require('../util');
var addToCart = require('./product/addToCart');

var magazine = {
    /**
     * @private
     * @function
     * @description init events for the Magazine Pages
     */
    init: function () {
		initializeEvents();
        addToCart();
	}
}

function enableCartButton(obj) {
	var container = obj.closest('.product__images__container');
	var btn = container.find('button[type="button"]');
	btn.removeAttr('disabled');
	if(!btn.hasClass('out-stk-btn')) {
		changeCartButtonText(btn, Resources.ADD_TO_CART_BUTTON);
	}
}

function updateCartButtonText(obj, text) {
	var container = obj.closest('.product__images__container');
	var btn = container.find('button[type="button"]');
	if(btn !== undefined) {
		changeCartButtonText(btn, text)
	}
	
}

function disableCartButton(obj) {
	var container = $('.magazine-article__section');
	var btn = container.find('button[type="button"].btn-add-to-bag');
	btn.attr('disabled', true);
	container.find('.add-to-bag, .inacactive-cart-btn').removeClass('active');
	if(!btn.hasClass('out-stk-btn')) {
		changeCartButtonText(btn, Resources.ADD_TO_CART_BUTTON);
	}
}

function resetCartForm() {
	var bagForm = $('.magazine-article  .pdpForm');
	bagForm[0].reset();
	
	return bagForm;
}

function changeCartButtonText(btn, text)
{
	btn.html(text);
	btn.attr('title', text);
}

function initializeEvents() {
	var $mainClass = $('body');

	// Toggle Product ID to hidden Fields
    $mainClass.on('click', '.add-to-bag:not(.active)', function () {
		var bagForm = resetCartForm();
		var currentObj = $(this);
		var url = currentObj.data('link');
		disableCartButton(currentObj);
		$.ajax({
            type: 'POST',
            url: util.ajaxUrl(url),
            success: function(response) { 
            	if(response.pid) {
            		if(response.inStock === true) {
	            		currentObj.addClass('active');
	            		bagForm.find('input[name="Quantity"]').val(1);
	            		bagForm.find('input[name="pid"]').val(response.pid);            		
	            		enableCartButton(currentObj);
            		} else {            			
            	    	updateCartButtonText(currentObj, Resources.OUT_OF_STOCK);
            		}
            	}
            }
        })
    });
    
    $mainClass.on('click', '.btn-direct-to-bag', function () {
    	var bagForm = resetCartForm();
    	var currentObj = $(this);
    	var pid = currentObj.data('product');
		var wrapDom = currentObj.closest('.section-add-to-bag');
		if(pid && wrapDom.length > 0) {
			bagForm.find('input[name="Quantity"]').val(1);
			bagForm.find('input[name="pid"]').val(pid);
			enableCartButton(currentObj);
			wrapDom.find('.link-add-to-bag').click();
		}
		
    });
    
    $mainClass.on('click', '.inacactive-cart-btn', function (e) {
    	e.preventDefault();
    	e.stopPropagation();
    	var currentObj = $(this);
    	disableCartButton(currentObj);	
    	currentObj.addClass('active');
    	updateCartButtonText(currentObj, Resources.OUT_OF_STOCK);
    });
    

	// Toggle Product tile on mobile
	$mainClass.on('click', '.mod-product-button-toggle', function() {
		var parent = $(this).closest('.magazine_container');
		var imgContainerClass = 'product__magazine_images__container';
		var imgQuickviewClass = 'product__magazine--quickview';
		var baseimgClass = '.product__images__container';

		if (parent.find(baseimgClass).hasClass(imgContainerClass)) {
			parent.find(baseimgClass).removeClass(
					imgContainerClass + ' ' + imgQuickviewClass);
			toggleMagazineButtonClass(parent, 'off');
		} else {
			reinitSlickContainer(parent);
			parent.find('.product__images__container').addClass(
					imgContainerClass + ' ' + imgQuickviewClass);
			toggleMagazineButtonClass(parent, 'on');

		}
	});
}

function reinitSlickContainer(obj) {
	var sizeContainer = obj.find('.product__sizes');
	sizeContainer.attr("style",
			"display: inline-block !important;");
	var prevBtn =  obj.find('.slick-prev');
	var baseWidth = 25;
	if(prevBtn.length > 0) {
		if(!prevBtn.hasClass('slick-prev-clicked')) {
			updateSlickItem(sizeContainer, baseWidth);
			prevBtn.click().addClass('slick-prev-clicked');
		}
	} else {
		updateSlickItem(sizeContainer, baseWidth, false);
	}
	
}

function toggleMagazineButtonClass(obj, type) {
	var baseButtonClass = 'mod-product-button-toggle';
	if (type == 'on') {
		obj.find('.'+baseButtonClass).addClass(baseButtonClass + '--close');
	} else {
		obj.find('.'+baseButtonClass).removeClass(baseButtonClass + '--close');
	}
}

function updateSlickItem(sizeContainer, baseWidth, nextSlide)
{
	var items = sizeContainer.find('li.product__sizes__item');
	var length = items.length;
	if(nextSlide === undefined) {
		nextSlide = true;
	}
	if(nextSlide || length == 2 || length == 3) {
		sizeContainer.find('.slick-track').css("width",(baseWidth*length)+"px")
		items.each(function(key, item) {
			$(item).css("width",baseWidth+"px");
		});
	}
	
}

module.exports = magazine;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/magazine.js